module.exports = __webpack_public_path__ + "static/media/32.eaa1804a.jpg";